// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"_56384eb","infoTooltip":"_671e04d"};